
import styled from 'styled-components';
import React from 'react';
import ProceduresContext from './ProceduresContext';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import FormControl from '@material-ui/core/FormControl';


const Container = styled.div`
    padding-left:20px;
    width:200px;
    border-color:red;
    margin-top:7px;
`;

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    background: 'white'
  },
}));

const customStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "rgb(61, 122, 150);" : null,
    boxShadow: 'none',
    border: state.isFocused ? '1.5px solid lightgray' : '1px solid lightgray', // default border color
    "&:hover": {
      borderColor: state.isFocused ? "rgb(61, 122, 150);" : "black"
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0,
    maxHeight: window.innerHeight - 300
  })
};

const ProceduresCategoryFilter = () => {
  const groupBy = (arr, prop) => {
    return Object.values(arr.reduce((aggregate, item) => {
      const val = item[prop];
      if (!aggregate[val]) {
        aggregate[val] = {
          [prop]: val,
          data: []
        };
      }
      aggregate[val].data.push(item);
      return aggregate;
    }, {}));
  }

  const classes = useStyles();
  const context = React.useContext(ProceduresContext);

  const { procedures, isProjectSpecific } = context;
  const selectedFunction = (context.isProjectSpecific || context.isProjectSpecificCorporate) ? procedures.selectedProjectFunction : procedures.selectedFunction;
  let proceduresList = procedures.procedures;
  console.log(context)


  if (context.isProjectSpecific) {
    proceduresList = procedures.projectSpecificProcedures;
  } else if (context.isProjectSpecificCorporate) {
    proceduresList = procedures.projectSpecificCorporateProcedures;
  }

  // exclude archived procedures
  proceduresList = proceduresList.filter((pl) => { return (!pl.archived) });

  // if status filter exists then apply that first
  if (context.statusFilterText !== "" && context.statusFilterText !== "All") {
    proceduresList = proceduresList.filter((pl) => { return (pl.isNew === context.statusFilterText) });
  }

  proceduresList = context.sortProceduresList(proceduresList);
  let proceduresWithAllOption = [];
  if (proceduresList && proceduresList.length > 0) {
    proceduresWithAllOption = [{ categoryName: 'All', gbuId: 0, isCorporate: false }].concat(proceduresList);
  }

  /*
  // find unique categories
  let uniqueCategoryList = [...new Set( proceduresWithAllOption.map(obj => obj.categoryName))];
  console.log(uniqueCategoryList)
  // filter the count for each unique category
  let filteredCategories = [];
  uniqueCategoryList.forEach(function (cat, index) {
    filteredCategories = proceduresList.filter((p) => { return  (p.categoryName === cat);}) 
    uniqueCategoryList[index] = (cat === 'All') ? cat : cat + ' (' + filteredCategories.length + ')';
  });
  console.log(filteredCategories)
  console.log(uniqueCategoryList)
  const buildCategoryData = category => {
    return { label: category, value : category }
  }

  uniqueCategoryList = uniqueCategoryList.map(buildCategoryData);
  let categoryList = [
    {
        label:"Categories",
        options:uniqueCategoryList
    },
  ]*/
  let proceduresWithAllAndNonGBUOption = proceduresWithAllOption.filter(x => x.gbuId === 0)
  let proceduresWithGBUOption = proceduresWithAllOption.filter(x => x.gbuId > 0 && !x.isCorporate)
  const groupByisCorporateAndCategoryName = groupBy(proceduresWithAllAndNonGBUOption, 'isCorporate')
    .map(item => ({ ...item, data: groupBy(item.data, 'categoryName') }));

  const groupByGbuIdAndCategoryName = groupBy(proceduresWithGBUOption, 'gbuId')
    .map(item => ({ ...item, data: groupBy(item.data, 'categoryName') }));

  let categoryList = [];
  groupByisCorporateAndCategoryName.forEach(function (corp) {
    let filteredCategories = [];
    corp.data.forEach(function (cat) {
      let category = (cat.categoryName === 'All') ? cat.categoryName : cat.categoryName + ' (' + cat.data.length + ')'
      filteredCategories.push({ label: category, value: category })
    });
    categoryList.push({ label: (corp.isCorporate === false ? "Categories" : 'Corporate'), options: filteredCategories })
  });

  groupByGbuIdAndCategoryName.forEach(function (gbu) {
    let filteredCategories = [];
    gbu.data.forEach(function (cat) {
      let category = (cat.categoryName === 'All') ? cat.categoryName : cat.categoryName + ' (' + cat.data.length + ')'
      filteredCategories.push({ label: category, value: category })
    });
    categoryList.push({ label: (gbu.gbuId === 0 ? "Categories" : context.procedures.gbus.find(x => x.id === gbu.gbuId).name), options: filteredCategories })
  });

  return <Container>
    <Select
      // value = {context.categoryFilterText}
      classes={classes}
      styles={customStyles}
      options={categoryList}
      onChange={(selectedCategeory) => {
        const category = selectedCategeory.value.substring(0, selectedCategeory.value.indexOf(' ('));
        context.setCategoryFilterText(category);
        context.showSnackBarMessage("Filter Successfully Applied.", null, 4000);
      }}
      placeholder="Category"

    />
  </Container>
}

export default ProceduresCategoryFilter;